/* TPL La Siesta motion (2026-10-31). One painter on TPLScrollBus, so there is no scroll listener of its own
   and nothing runs while the page is still (the bus only fires on scroll and resize).
   Borrowed from motion.dev: "Scroll Image Reveal" / "curtains iris" (the aperture), "Parallax" (the drift),
   "Text scroll word reveal" (the lead line).
     1. Lead line and the quote line: words light up as the line scrolls in.
     2. Editorial photographs ([data-lse-drift]): drift up or down against the scroll.
     3. Piece tiles (.tpl-tier__media): open from the middle like the cut window of a mat, then clear
        their clip-path completely so hover and swipe behave as before.
     4. Room spreads (.tpl-tier__figpic img): a gentle drift, opposite directions left and right.
   Reduced motion: the script does nothing, the page stays in its finished state. */
(function () {
  'use strict';
  if (window.__tplLsMotion) return;
  window.__tplLsMotion = true;

  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (reduced) return;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  var wordBlocks = [];   /* { el, words[] } */
  var drifts = [];       /* { el, dir, amp, img } */
  var tiles = [];        /* { el, done } */

  function splitWords(el) {
    var text = (el.textContent || '').trim();
    if (!text) return null;
    var parts = text.split(/\s+/);
    el.setAttribute('aria-label', text);
    el.textContent = '';
    var spans = [];
    parts.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'tpl-lse__w';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = w;
      el.appendChild(s);
      if (i < parts.length - 1) el.appendChild(document.createTextNode(' '));
      spans.push(s);
    });
    return spans;
  }

  function collect() {
    document.querySelectorAll('[data-lse-lead], .tpl-tier__linetext').forEach(function (el) {
      if (el.dataset.lsWords) return;
      var spans = splitWords(el);
      if (!spans) return;
      el.dataset.lsWords = '1';
      var root = el.closest('.tpl-lse') || el.closest('.tpl-tier__line') || el;
      root.classList.add('tpl-lse--live');
      wordBlocks.push({ el: el, words: spans });
    });

    document.querySelectorAll('[data-lse-drift]').forEach(function (el) {
      if (el.dataset.lsDrift2) return;
      el.dataset.lsDrift2 = '1';
      drifts.push({ el: el, dir: parseFloat(el.getAttribute('data-lse-drift')) || 1, amp: 42, img: false });
    });

    document.querySelectorAll('.tpl-tier__spread').forEach(function (sp) {
      sp.querySelectorAll('.tpl-tier__fig').forEach(function (fig, i) {
        var pic = fig.querySelector('.tpl-tier__figpic img');
        if (!pic || pic.dataset.lsDrift2) return;
        pic.dataset.lsDrift2 = '1';
        pic.style.transform = 'scale(1.1)';
        drifts.push({ el: fig, dir: i % 2 === 0 ? -1 : 1, amp: 16, img: pic });
      });
    });

    /* editorial video: plays only while on screen, pauses when it leaves (battery, data) */
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.25 });
      document.querySelectorAll('video[data-lse-video]').forEach(function (v) {
        if (v.dataset.lsVio) return;
        v.dataset.lsVio = '1';
        vio.observe(v);
      });
    }

    var vh = window.innerHeight;
    /* 2026-11-01 (owner): the same opening on the product page: The Duo wall, Pairs with, More in, the phone build film */
    document.querySelectorAll('.tpl-tier__media, .tpl-hls--grid .tpl-hls__media, .tpl-pb__wall, .tpl-mb__wall, .tpl-mc__media, .tpl-m3d-mvid__v').forEach(function (m) {
      if (m.dataset.lsAp) return;
      m.dataset.lsAp = '1';
      var r = m.getBoundingClientRect();
      /* tiles already on screen at load keep their normal look; only tiles still below the fold open up */
      if (r.top > vh * 0.92) {
        m.style.clipPath = 'inset(46% round 2px)';
        tiles.push({ el: m, done: false });
      }
    });
  }

  var painter = {
    read: function () {
      var vh = window.innerHeight;
      var s = { vh: vh, words: [], drifts: [], tiles: [] };
      var i, r;
      for (i = 0; i < wordBlocks.length; i++) s.words.push(wordBlocks[i].el.getBoundingClientRect().top);
      for (i = 0; i < drifts.length; i++) { r = drifts[i].el.getBoundingClientRect(); s.drifts.push([r.top, r.height]); }
      for (i = 0; i < tiles.length; i++) {
        if (tiles[i].done) { s.tiles.push(null); continue; }
        r = tiles[i].el.getBoundingClientRect();
        s.tiles.push(r.height ? r.top : null);
      }
      return s;
    },
    write: function (s) {
      var vh = s.vh, i;
      for (i = 0; i < wordBlocks.length; i++) {
        var p = clamp((vh * 0.84 - s.words[i]) / (vh * 0.5), 0, 1);
        var on = Math.round(p * wordBlocks[i].words.length);
        for (var k = 0; k < wordBlocks[i].words.length; k++) {
          wordBlocks[i].words[k].classList.toggle('is-on', k < on);
        }
      }
      for (i = 0; i < drifts.length; i++) {
        var top = s.drifts[i][0], h = s.drifts[i][1];
        if (top > vh * 1.4 || top + h < -vh * 0.4) continue;
        var c = ((top + h / 2) - vh / 2) / vh;           /* about -1 .. 1 */
        var y = (-c * drifts[i].dir * drifts[i].amp).toFixed(1);
        if (drifts[i].img) drifts[i].img.style.transform = 'translate3d(0,' + y + 'px,0) scale(1.1)';
        else drifts[i].el.style.transform = 'translate3d(0,' + y + 'px,0)';
      }
      for (i = 0; i < tiles.length; i++) {
        var t = tiles[i], top2 = s.tiles[i];
        if (t.done || top2 === null) continue;
        var q = clamp((vh * 0.98 - top2) / (vh * 0.4), 0, 1);
        q = 1 - (1 - q) * (1 - q);                        /* ease out */
        if (q >= 1) { t.el.style.clipPath = ''; t.done = true; continue; }
        t.el.style.clipPath = 'inset(' + ((1 - q) * 46).toFixed(1) + '% round 2px)';
      }
    }
  };

  function start() {
    collect();
    if (window.TPLScrollBus && window.TPLScrollBus.add) {
      window.TPLScrollBus.add(painter);
    } else {
      /* bus failed to load: one passive listener, same painter, same read/write order */
      var ticking = false;
      var run = function () { ticking = false; painter.write(painter.read()); };
      var kick = function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } };
      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick, { passive: true });
      kick();
    }
    /* tiles can arrive late (recolour, filters, a lazy second pass): look again once after load */
    window.addEventListener('load', function () {
      collect();
      if (window.TPLScrollBus && window.TPLScrollBus.schedule) window.TPLScrollBus.schedule();
    }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
